import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";

// Fabric Imports
import { fetchWrapper } from "../../../helpers/fetchwrapper";

import { baseUrl } from "../../../helpers/constants";
import { ValidatePassword } from "../../../helpers/passwordValidator";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  MessageBar,
  Image,
  Text,
  Field,
  Link,
  Input,
  ProgressBar,
  Button,
} from "@fluentui/react-components";
import { KeyResetRegular } from "@fluentui/react-icons";

function ResetPassword(props: any) {
  const navigate = useNavigate();
  const [resetValues, setResetValues] = useState({
    userName: "",
    token: "",
    password: "",
    confirmPassword: "",
  });
  const handleResetValuesChange = (name: string, val: any) => {
    setResetValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const [passwordStrength, setPasswordStrength] = useState(0);

  const [errorMessage, setErrorMessage] = useState(
    i18n.t<string>("pwTooShort") ? i18n.t<string>("pwTooShort") : "",
  );

  const FormValidation = (): void => {
    fetchWrapper
      .post(`${baseUrl}/api/account/resetpassword`, resetValues)
      .then(() => {
        navigate("/account/login");
      })
      .catch((error: any) => {
        setErrorMessage(error);
      });
  };

  useEffect(() => {
    const id = window.location.search.substring(
      window.location.search.indexOf("userId=") + 7,
      window.location.search.indexOf("&token="),
    );
    const token = window.location.search.substring(
      window.location.search.indexOf("&token=") + 7,
    );
    setResetValues({
      userName: id!,
      token: token!,
      password: "",
      confirmPassword: "",
    });
  }, []);

  const CheckValidPassword = (changedField: string, value: string): void => {
    let password = "";
    let confirmPassword = "";

    if (changedField == "password") {
      password = value;
      confirmPassword = resetValues.confirmPassword;
    } else {
      password = resetValues.password;
      confirmPassword = value;
    }

    const result = ValidatePassword(password);
    setPasswordStrength(result / 100);

    if (result < 100) {
      setErrorMessage(i18n.t<string>("pwdNotValid"));
    } else if (password != confirmPassword) {
      setErrorMessage(i18n.t<string>("pwNotMatching"));
    } else {
      setErrorMessage("");
    }
  };

  const windowSize = useWindowSize();

  return (
    <div>
      <div className="blockContainerContentCentered">
        <div
          style={{
            borderRadius: "11px",
            backgroundColor: "white",
            boxShadow: "0 0 8px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.14)",
            minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
            maxWidth: 500,
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            marginBottom: 20,
            animationDuration: "4s",
          }}
        >
          <div style={{ padding: 20 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Link onClick={() => navigate("/")}>
                <Image
                  src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                  height={50}
                  className="lueb-MarginBottom30"
                />
              </Link>
            </div>
            <div className="lueb-padding5 lueb-MarginTopBottom10">
              <form
                onSubmit={() => {
                  FormValidation();
                }}
              >
                <h3 className="lueb-MarginTopBottom10">
                  {i18n.t<string>("resetPassword")}
                </h3>
                <div className="lueb-MarginTopBottom10">
                  <Text>{i18n.t<string>("resetPasswordText")}</Text>
                </div>
                <Field label={i18n.t<string>("email")}>
                  <Input
                    appearance="underline"
                    value={resetValues.userName}
                    placeholder={i18n.t<string>("email")}
                    onChange={(ev: any, data) => {
                      handleResetValuesChange("userName", data.value);
                    }}
                  />
                </Field>

                {/* <TextField
                  className="lueb-MarginBottom20"
                  underlined
                  value={resetValues.token}
                  placeholder={i18n.t<string>("verifyToken")}
                  onChange={(ev: any, newText: any) => {
                    handleResetValuesChange("token", newText ? newText : "");
                  }}
                /> */}
                <Field
                  style={{ marginTop: "5px" }}
                  label={i18n.t<string>("password")}
                >
                  <Input
                    appearance="underline"
                    type="password"
                    value={resetValues.password}
                    placeholder={i18n.t<string>("password")}
                    onChange={(ev: any, data) => {
                      handleResetValuesChange("password", data.value);
                      CheckValidPassword("password", data.value);
                    }}
                  />
                </Field>

                <Field
                  style={{ marginTop: "5px" }}
                  label={i18n.t<string>("confirmPassword")}
                >
                  <Input
                    appearance="underline"
                    type="password"
                    placeholder={i18n.t<string>("confirmPassword")}
                    value={resetValues.confirmPassword}
                    onChange={(ev: any, data) => {
                      handleResetValuesChange("confirmPassword", data.value);
                      CheckValidPassword("confirmPassword", data.value);
                    }}
                  />
                </Field>
                {passwordStrength > 0.0 && passwordStrength < 1.0 && (
                  <ProgressBar
                    style={{ marginTop: "5px" }}
                    value={passwordStrength}
                    thickness="large"
                  />
                )}
                {errorMessage != "" && (
                  <MessageBar style={{ marginTop: "5px" }} intent={"error"}>
                    {i18n.t<string>(errorMessage)}
                  </MessageBar>
                )}
                <div className="lueb-padding5 lueb-MarginTopBottom10 lueb-floatRight">
                  <Button
                    appearance="primary"
                    disabled={errorMessage != ""}
                    onClick={() => FormValidation()}
                    icon={<KeyResetRegular />}
                  >
                    {i18n.t<string>("resetPassword")}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
